export const IPC_RENDERER_KEY_PREFIX = 'nxdb-ipc-renderer-storage';
export const IPC_RENDERER_TO_MAIN = 'nxdb-renderer-to-main';
